import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import image from "../../../helper/image";
import { Dialog, Switch, Tooltip, InputLabel } from "@material-ui/core";

import ProfileSearchBox from "../../fields/ProfileSearchBox";
import RichTextEditor from "../../richTextEditor/RichTextEditor";

import "./StaffAgentInvitationModal.css";

@inject("profileStore", "venueStore", "templateStore", "agentVenueStore", "userInvitationStore")
@observer
class StaffAgentInvitationModal extends Component {
    state = {
        loading: false,
        inviteNewUser: false,
        venueSearchTerm: ""
    };

    submissionGeneration = 0;

    constructor(props) {
        super(props);
        if (!Array.isArray(this.props.availableVenues)) {
            this.props.venueStore.resetVenues();
        }
    }

    componentWillUnmount() {
        this.submissionGeneration += 1;
    }

    componentWillReceiveProps(nextProps) {
        if (String(nextProps.profileId) !== String(this.props.profileId)) {
            this.submissionGeneration += 1;
            this.props.agentVenueStore.resetInvitationField();
            this.setState({
                loading: false,
                inviteNewUser: false,
                venueSearchTerm: ""
            });
        } else if (this.props.open && !nextProps.open) {
            this.submissionGeneration += 1;
            this.setState({ loading: false });
        }

        if (nextProps && nextProps.open && !this.props.open) {
            if (!Array.isArray(nextProps.availableVenues)) {
                this.props.templateStore.showLoadingScreen();
                this.props.venueStore.load().then(() => {
                    this.props.templateStore.hideLoadingScreen();
                }).catch(error => {
                    this.props.templateStore.hideLoadingScreen();
                    this.props.templateStore.openSnackbar(error.message || "Unable to load venues.");
                });
            }
            this.setState({
                ...this.state,
                inviteNewUser: false,
                venueSearchTerm: ""
            });
        }
    }

    isCurrentProfile = profileId => {
        if (profileId == null || this.props.profileId == null) return true;
        const currentProfileId = this.props.profileStore.getCurrentProfile()?.id;
        return String(profileId) === String(this.props.profileId) &&
            String(profileId) === String(currentProfileId);
    };

    handleInvite = async () => {
        if (this.state.loading || this.isInviteButtonDisabled()) return;
        const actingProfileId = this.props.profileId ??
            this.props.profileStore.getCurrentProfile()?.id;
        if (!this.isCurrentProfile(actingProfileId)) {
            this.props.agentVenueStore.resetInvitationField();
            if (String(this.props.profileId) === String(actingProfileId)) {
                this.props.onClose();
            }
            return;
        }
        const generation = ++this.submissionGeneration;
        const { inviteNewUser } = this.state;

        this.setState({ loading: true });
        this.props.templateStore.showLoadingScreen();
        try {
            if (inviteNewUser) {
                await this.props.userInvitationStore.inviteStaffAgent(
                    this.props.agentVenueStore.manage,
                    this.props.agentVenueStore.manageSocialPost
                );
            } else {
                await this.props.agentVenueStore.inviteAgentByStaff();
            }
            if (generation !== this.submissionGeneration || !this.isCurrentProfile(actingProfileId)) {
                return;
            }
            if (this.props.onSuccess) {
                await this.props.onSuccess();
            } else {
                await this.props.agentVenueStore.getStaffVenueAgentRequest();
            }
            if (generation === this.submissionGeneration && this.isCurrentProfile(actingProfileId)) {
                this.props.onClose();
            }
        } catch (error) {
            this.props.templateStore.openSnackbar(
                error?.message || error || "Unable to send the agent invitation."
            );
        } finally {
            if (generation === this.submissionGeneration) {
                this.setState({ loading: false });
            }
            this.props.templateStore.hideLoadingScreen();
        }
    };

    handleSelect = item => {
        this.props.agentVenueStore.setInvitedProfile(item);
        this.setState({ 
            ...this.state,
            inviteNewUser: false
        });
    };

    getInvitationMessage = () => {
        return this.props.agentVenueStore.invitationMessage;
    };

    handleInvitationMessageChange = value => {
        this.props.agentVenueStore.setInvitationMessage(value);
    };

    syncManage = () => {
        this.props.agentVenueStore.setManage(!this.props.agentVenueStore.manage);
    };

    syncSocialPost = () => {
        this.props.agentVenueStore.setSocialPost(!this.props.agentVenueStore.manageSocialPost);
    };

    handleNoAgentFound = value => {
        this.props.userInvitationStore.resetInvitedData();
        this.setState(
            {
                ...this.state,
                inviteNewUser: true
            },
            () => {
                var names = value.match(/\S+/g) || [];

                if (names && names[0]) {
                    this.props.userInvitationStore.setInvitedUserFirstName(names[0]);
                }
                if (names && names[names.length - 1]) {
                    this.props.userInvitationStore.setInvitedUserLastName(names[names.length - 1]);
                }
            }
        );
    };

    isInviteButtonDisabled = () => {
        if (this.state.loading) return true;
        const { inviteNewUser } = this.state;
        const { errors, invitedUserFirstName, invitedUserLastName, invitedUserEmail } = this.props.userInvitationStore;
        const { invitedProfile, invitedVenues } = this.props.agentVenueStore;
        if (inviteNewUser) {
            const isError = errors?.firstName || errors?.lastName || errors?.actName || errors?.email;
            return invitedVenues.length === 0 || isError || !invitedUserFirstName || !invitedUserLastName || !invitedUserEmail;
        } else {
            return !invitedProfile || invitedVenues.length === 0;
        }
    };

    handleClearInvitedProfile = () => {
        this.props.agentVenueStore.setInvitedProfile(undefined);
        this.props.agentVenueStore.setInvitedVenues([]);
    };

    handleBackToSearch = () => {
        this.props.userInvitationStore.resetInvitedData();
        this.props.agentVenueStore.setInvitedVenues([]);
        this.setState({
            ...this.state,
            inviteNewUser: false
        });
    };

    handleValidate(value, type) {
        switch (type) {
            case "firstName":
                this.props.userInvitationStore.validateInvitedUserFirstName(value);
                break;
            case "lastName":
                this.props.userInvitationStore.validateInvitedUserLastName(value);
                break;
            case "email":
                this.props.userInvitationStore.validateInvitedUserEmail(value);
                break;
            default:
                break;
        }
    }

    extractInitials = name => {
        if (!name) return "";
        const parts = name.split(" ");
        let initials = "";
        if (parts[0]) initials += parts[0].charAt(0);
        if (parts[1]) initials += parts[1].charAt(0);
        return initials.toUpperCase();
    };

    isVenueDisabled = (venue) => {
        const { inviteNewUser } = this.state;
        const { pendingAgentVenues, agentVenues, invitedProfile } = this.props.agentVenueStore;
        
        const isPending = pendingAgentVenues.filter(
            x =>
                (x.primaryProfileId === venue.id && invitedProfile && x.secondaryProfileId === invitedProfile.id) ||
                (x.secondaryProfileId === venue.id && invitedProfile && x.primaryProfileId === invitedProfile.id)
        ).length > 0;
        
        const isExisting = agentVenues.filter(x => x.venueId === venue.id && invitedProfile && x.agentId === invitedProfile.id).length > 0;
        
        return isPending || isExisting || (!invitedProfile && !inviteNewUser);
    };

    getVenueDisabledReason = (venue) => {
        const { inviteNewUser } = this.state;
        const { pendingAgentVenues, agentVenues, invitedProfile } = this.props.agentVenueStore;
        
        if (!invitedProfile && !inviteNewUser) {
            return "Select an agent first";
        }
        
        const isPending = pendingAgentVenues.filter(
            x =>
                (x.primaryProfileId === venue.id && invitedProfile && x.secondaryProfileId === invitedProfile.id) ||
                (x.secondaryProfileId === venue.id && invitedProfile && x.primaryProfileId === invitedProfile.id)
        ).length > 0;
        
        if (isPending) {
            return "Invitation already pending for this venue";
        }
        
        const isExisting = agentVenues.filter(x => x.venueId === venue.id && invitedProfile && x.agentId === invitedProfile.id).length > 0;
        
        if (isExisting) {
            return "Agent already has access to this venue";
        }
        
        return "";
    };

    isVenueSelected = (venue) => {
        const { invitedVenues } = this.props.agentVenueStore;
        return invitedVenues.filter(x => x.id === venue.id).length > 0;
    };

    toggleVenue = (venue) => {
        if (this.isVenueDisabled(venue)) return;
        
        const { invitedVenues } = this.props.agentVenueStore;
        const isSelected = this.isVenueSelected(venue);
        
        if (isSelected) {
            const newVenues = invitedVenues.filter(x => x.id !== venue.id);
            this.props.agentVenueStore.setInvitedVenues(newVenues);
        } else {
            const newVenues = [...invitedVenues, venue];
            this.props.agentVenueStore.setInvitedVenues(newVenues);
        }
    };

    renderAgentSearch = () => {
        const { inviteNewUser } = this.state;
        const { invitedProfile } = this.props.agentVenueStore;
        const { invitedUserFirstName, invitedUserLastName, invitedUserEmail, errors } = this.props.userInvitationStore;

        if (invitedProfile && !inviteNewUser) {
            return (
                <div className="invite-agent-selected-card">
                    {invitedProfile.profileImage ? (
                        <img 
                            src={image.getProfileImage(invitedProfile)} 
                            alt={invitedProfile.fullName}
                            className="invite-agent-selected-avatar"
                        />
                    ) : (
                        <div className="invite-agent-selected-avatar">
                            {this.extractInitials(invitedProfile.fullName)}
                        </div>
                    )}
                    <div className="invite-agent-selected-info">
                        <strong>{invitedProfile.fullName}</strong>
                        <span>{invitedProfile.email || "Agent"}</span>
                    </div>
                    <i className="fa fa-check-circle invite-agent-selected-check"></i>
                    {!this.props.onProfile && (
                        <button 
                            className="invite-agent-selected-clear"
                            onClick={this.handleClearInvitedProfile}
                        >
                            <i className="fa fa-times"></i>
                        </button>
                    )}
                </div>
            );
        }

        if (inviteNewUser) {
            return (
                <Fragment>
                    <button 
                        className="invite-agent-back-link"
                        onClick={this.handleBackToSearch}
                    >
                        <i className="fa fa-arrow-left"></i> Back to search
                    </button>
                    <div className="invite-agent-new-fields">
                        <div className="invite-agent-new-fields-row">
                            <div className="form-group">
                                <label>First Name</label>
                                <input 
                                    type="text"
                                    value={invitedUserFirstName}
                                    onChange={e => this.props.userInvitationStore.setInvitedUserFirstName(e.target.value)}
                                    onBlur={e => this.handleValidate(e.target.value, "firstName")}
                                    className={errors?.firstName ? "error" : ""}
                                    placeholder="Enter first name"
                                />
                                {errors?.firstName && <div className="error-text">{errors.firstName}</div>}
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input 
                                    type="text"
                                    value={invitedUserLastName}
                                    onChange={e => this.props.userInvitationStore.setInvitedUserLastName(e.target.value)}
                                    onBlur={e => this.handleValidate(e.target.value, "lastName")}
                                    className={errors?.lastName ? "error" : ""}
                                    placeholder="Enter last name"
                                />
                                {errors?.lastName && <div className="error-text">{errors.lastName}</div>}
                            </div>
                        </div>
                        <div className="invite-agent-new-fields-row">
                            <div className="form-group">
                                <label>Email Address</label>
                                <input 
                                    type="email"
                                    value={invitedUserEmail}
                                    onChange={e => this.props.userInvitationStore.setInvitedUserEmail(e.target.value)}
                                    onBlur={e => this.handleValidate(e.target.value, "email")}
                                    className={errors?.email ? "error" : ""}
                                    placeholder="Enter email address"
                                />
                                {errors?.email && <div className="error-text">{errors.email}</div>}
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        return (
            <div className="invite-agent-search-wrapper">
                <i className="fa fa-search"></i>
                <ProfileSearchBox
                    placeholder="Search by name or email..."
                    id="invite-agent-search"
                    handleSearch={value => this.props.profileStore.searchAgencyProfile(value)}
                    handleChange={this.handleSelect}
                    handleEmpty={this.handleNoAgentFound}
                    menuStyle={{
                        position: "absolute",
                        maxHeight: "200px",
                        overflowY: "auto",
                        width: "100%",
                        zIndex: 1000
                    }}
                />
            </div>
        );
    };

    handleVenueSearchChange = (e) => {
        this.setState({ venueSearchTerm: e.target.value });
    };

    getFilteredVenues = () => {
        const venues = this.getAvailableVenues();
        const { venueSearchTerm } = this.state;
        
        if (!venues) return [];
        if (!venueSearchTerm.trim()) return venues;
        
        const searchLower = venueSearchTerm.toLowerCase().trim();
        return venues.filter(venue => {
            const name = (venue.fullName || "").toLowerCase();
            const city = (venue.city || "").toLowerCase();
            return name.includes(searchLower) || city.includes(searchLower);
        });
    };

    getAvailableVenues = () => {
        return Array.isArray(this.props.availableVenues)
            ? this.props.availableVenues
            : this.props.venueStore.venues;
    };

    selectAllFilteredVenues = () => {
        const filteredVenues = this.getFilteredVenues();
        const selectableVenues = filteredVenues.filter(v => !this.isVenueDisabled(v));
        const { invitedVenues } = this.props.agentVenueStore;
        
        const allFilteredSelected = selectableVenues.every(v => 
            invitedVenues.some(iv => iv.id === v.id)
        );
        
        if (allFilteredSelected) {
            const newSelection = invitedVenues.filter(iv => 
                !selectableVenues.some(sv => sv.id === iv.id)
            );
            this.props.agentVenueStore.setInvitedVenues(newSelection);
        } else {
            const currentIds = new Set(invitedVenues.map(v => v.id));
            const newVenues = selectableVenues.filter(v => !currentIds.has(v.id));
            this.props.agentVenueStore.setInvitedVenues([...invitedVenues, ...newVenues]);
        }
    };

    renderVenueChips = () => {
        const venues = this.getAvailableVenues();
        const { venueSearchTerm } = this.state;
        const filteredVenues = this.getFilteredVenues();
        const selectableVenues = filteredVenues.filter(v => !this.isVenueDisabled(v));
        const totalVenues = venues?.length || 0;

        return (
            <Fragment>
                <div className="venue-search-row">
                    <div className="venue-search-input-wrapper">
                        <i className="fa fa-search"></i>
                        <input 
                            type="text"
                            placeholder="Search venues..."
                            value={venueSearchTerm}
                            onChange={this.handleVenueSearchChange}
                            className="venue-search-input"
                        />
                        {venueSearchTerm && (
                            <button 
                                className="venue-search-clear"
                                onClick={() => this.setState({ venueSearchTerm: "" })}
                            >
                                <i className="fa fa-times"></i>
                            </button>
                        )}
                    </div>
                    <span className="venue-count">
                        Showing {filteredVenues.length} of {totalVenues} venues
                    </span>
                    {selectableVenues.length > 0 && (
                        <button className="venue-select-all" onClick={this.selectAllFilteredVenues}>
                            Select All{venueSearchTerm ? ` (${selectableVenues.length})` : ""}
                        </button>
                    )}
                </div>
                <div className="venue-chips-grid">
                    {filteredVenues.map(venue => {
                        const isDisabled = this.isVenueDisabled(venue);
                        const isSelected = this.isVenueSelected(venue);
                        const disabledReason = isDisabled ? this.getVenueDisabledReason(venue) : "";
                        
                        const chipContent = (
                            <Fragment>
                                {venue.profileImage ? (
                                    <img 
                                        src={image.getProfileImage(venue)} 
                                        alt={venue.fullName}
                                        className="venue-chip-avatar"
                                    />
                                ) : (
                                    <div className="venue-chip-avatar">
                                        {this.extractInitials(venue.fullName)}
                                    </div>
                                )}
                                <span>{venue.fullName}</span>
                                {isSelected && <i className="fa fa-check venue-chip-check"></i>}
                            </Fragment>
                        );
                        
                        if (isDisabled && disabledReason) {
                            return (
                                <Tooltip key={venue.id} title={disabledReason}>
                                    <div 
                                        className={`venue-chip ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                        onClick={() => this.toggleVenue(venue)}
                                    >
                                        {chipContent}
                                    </div>
                                </Tooltip>
                            );
                        }
                        
                        return (
                            <div 
                                key={venue.id}
                                className={`venue-chip ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                onClick={() => this.toggleVenue(venue)}
                            >
                                {chipContent}
                            </div>
                        );
                    })}
                    {filteredVenues.length === 0 && venueSearchTerm && (
                        <div className="venue-chips-empty">
                            No venues match "{venueSearchTerm}"
                        </div>
                    )}
                </div>
            </Fragment>
        );
    };

    renderDayChips = () => {
        const days = [
            { key: "monday", label: "Mon" },
            { key: "tuesday", label: "Tue" },
            { key: "wednesday", label: "Wed" },
            { key: "thursday", label: "Thu" },
            { key: "friday", label: "Fri" },
            { key: "saturday", label: "Sat" },
            { key: "sunday", label: "Sun" }
        ];

        return (
            <div className="day-chips-grid">
                {days.map(day => (
                    <div 
                        key={day.key}
                        className={`day-chip ${this.props.agentVenueStore.dayToBook[day.key] ? 'selected' : ''}`}
                        onClick={() => this.props.agentVenueStore.toggleDayToBook(day.key)}
                    >
                        {day.label}
                        {this.props.agentVenueStore.dayToBook[day.key] && " ✓"}
                    </div>
                ))}
            </div>
        );
    };

    renderPermissions = () => {
        const { invitedProfile, manage, manageSocialPost } = this.props.agentVenueStore;
        const canManageSocial = invitedProfile?.agentProPlan;

        return (
            <div className="invite-agent-permissions">
                <div className="invite-agent-permission-item">
                    <div className="invite-agent-permission-info">
                        <i className="fa fa-star"></i>
                        <span>Manage Favourite Acts</span>
                    </div>
                    <Switch
                        checked={manage}
                        onChange={this.syncManage}
                        color="primary"
                    />
                </div>
                <Tooltip title={!canManageSocial ? "Agency needs to be subscribed to the Pro Plan to enable this feature." : ""}>
                    <div className={`invite-agent-permission-item ${!canManageSocial ? 'disabled' : ''}`}>
                        <div className="invite-agent-permission-info">
                            <i className="fa fa-share-alt"></i>
                            <span>Manage Social Posts</span>
                            {!canManageSocial && <span className="invite-agent-pro-badge">PRO</span>}
                        </div>
                        <Switch
                            checked={manageSocialPost}
                            onChange={this.syncSocialPost}
                            disabled={!canManageSocial}
                            color="primary"
                        />
                    </div>
                </Tooltip>
            </div>
        );
    };

    render() {
        const { inviteNewUser } = this.state;

        return (
            <Dialog 
                open={this.props.open} 
                onClose={this.props.onClose}
                className="invite-agent-modal"
                maxWidth="sm"
                fullWidth
            >
                <div className="invite-agent-modal-header">
                    <h2>
                        <i className="fa fa-user-plus"></i>
                        {inviteNewUser ? "Invite New Agent" : "Invite Agent"}
                    </h2>
                    <button className="close-btn" onClick={this.props.onClose}>
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="invite-agent-modal-body">
                    <div className="invite-agent-section">
                        <div className="invite-agent-section-label">Find Agent</div>
                        {this.renderAgentSearch()}
                    </div>

                    <div className="invite-agent-divider"></div>

                    <div className="invite-agent-section">
                        <div className="invite-agent-section-label">Select Venues</div>
                        {this.renderVenueChips()}
                    </div>

                    <div className="invite-agent-divider"></div>

                    <div className="invite-agent-section">
                        <div className="invite-agent-section-label">Booking Days</div>
                        {this.renderDayChips()}
                        <div className="invite-agent-helper-text">
                            Agent can only create bookings on selected days
                        </div>
                    </div>

                    <div className="invite-agent-divider"></div>

                    <div className="invite-agent-section">
                        <div className="invite-agent-section-label">Permissions</div>
                        {this.renderPermissions()}
                    </div>

                    <div className="invite-agent-divider"></div>

                    <div className="invite-agent-section">
                        <div className="invite-agent-message-label">
                            <InputLabel>Invitation Message</InputLabel>
                            <span className="optional">(Optional)</span>
                        </div>
                        <RichTextEditor
                            label="Invitation Message"
                            value={this.getInvitationMessage()}
                            onChange={this.handleInvitationMessageChange}
                        />
                    </div>
                </div>

                <div className="invite-agent-modal-footer">
                    <button className="invite-agent-btn invite-agent-btn-secondary" onClick={this.props.onClose}>
                        Cancel
                    </button>
                    <button 
                        className="invite-agent-btn invite-agent-btn-primary"
                        onClick={this.handleInvite}
                        disabled={this.state.loading || this.isInviteButtonDisabled()}
                        id="invite-agent-submit"
                    >
                        Send Invitation
                    </button>
                </div>
            </Dialog>
        );
    }
}

export default StaffAgentInvitationModal;
